module.exports = __webpack_public_path__ + "fonts/Gilroy-RegularItalic.5b729efb.woff";